import React from 'react';
import PropTypes from 'prop-types';
import { hot } from 'react-hot-loader';
import { connect } from 'react-redux';
import { universal } from '../../components/loadable';
import { selectSubscribeModals } from '../../../ReduxStorage/SubscriptionPlans/SubscribeModals/selectors';
import {
  closeEducatorModal,
  closePersonalPlanModal,
} from '../../../ReduxStorage/SubscriptionPlans/SubscribeModals/dispatchers';

const SubscribeAsEducatorModal = universal(
  import('./SubscribeAsEducatorModal'),
  {
    key: 'SubscribeAsEducatorModal',
  }
);

const PersonalPlanModal = universal(import('./PersonalPlanModal'), {
  key: 'PersonalPlanModal',
});

const LoadableSubscribeModals_ = (props) => {
  const { modals, onCloseEducatorModal, onClosePersonalModal } = props;
  if (modals.educator.show) {
    return (
      <SubscribeAsEducatorModal
        show
        showClose={modals.educator.canDismiss}
        onClose={onCloseEducatorModal}
      />
    );
  }

  if (modals.personal.show) {
    return (
      <PersonalPlanModal
        show
        showClose={modals.personal.canDismiss}
        mode={modals.personal.mode}
        onClose={onClosePersonalModal}
      />
    );
  }

  return null;
};
LoadableSubscribeModals_.propTypes = {
  modals: PropTypes.shape({
    educator: PropTypes.shape({
      show: PropTypes.bool.isRequired,
      canDismiss: PropTypes.bool.isRequired,
    }).isRequired,
    personal: PropTypes.shape({
      show: PropTypes.bool.isRequired,
      canDismiss: PropTypes.bool.isRequired,
      mode: PropTypes.oneOf(['trial', 'subscribe']),
    }).isRequired,
  }).isRequired,
  onCloseEducatorModal: PropTypes.func.isRequired,
  onClosePersonalModal: PropTypes.func.isRequired,
};

const mapState = (state) => {
  return {
    modals: selectSubscribeModals(state),
  };
};

const mapDispatch = (dispatch) => {
  return {
    onCloseEducatorModal: () => dispatch(closeEducatorModal()),
    onClosePersonalModal: () => dispatch(closePersonalPlanModal()),
  };
};

export const LoadableSubscribeModals = hot(module)(
  connect(
    mapState,
    mapDispatch
  )(LoadableSubscribeModals_)
);
